import { useBusinessUnitStore } from "@/stores/businessUnit";

export function MobileFacilityContext() {
  const selected = useBusinessUnitStore((state) => state.currentBusinessUnit);
  const units = useBusinessUnitStore((state) => state.businessUnits);
  const name = units.find((unit) => String(unit.id) === selected)?.name;
  if (!name) return null;
  return (
    <div
      className="flex min-w-0 items-start gap-2 border-b border-border/40 bg-card px-3 py-2 text-xs sm:hidden"
      aria-label={`Current facility: ${name}`}
    >
      <span className="shrink-0 text-muted-foreground">Facility</span>
      <span className="min-w-0 break-words font-medium">{name}</span>
    </div>
  );
}
